import React from 'react';
import styled, { css } from 'styled-components';
import { func, bool } from 'prop-types';
import Icon from '../../Icon';

const LeftArrowWrapperForHotel = css`
  left: 8px;
`;

const LeftArrowWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: inline-flex;
  z-index: 1;
  align-items: center;
  ${({ isHotel }) => {
    return isHotel && LeftArrowWrapperForHotel;
  }}
`;

const LeftArrowButtonForHotel = css`
  background-color: rgba(0, 0, 0, 0.72);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
`;

const LeftArrowButton = styled.button`
  background-color: ${({ disabled }) =>
    disabled ? 'transparent' : 'transparent'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: #ffffff;
  border: none;
  ${({ isHotel }) => {
    return isHotel && LeftArrowButtonForHotel;
  }}
`;

const LeftArrow = ({ onClick, disabled, isHotel }) => {
  const _handleClick = ev => {
    ev.stopPropagation();
    onClick(ev);
  };

  return (
    <LeftArrowWrapper isHotel={isHotel}>
      <LeftArrowButton
        onClick={_handleClick}
        disabled={disabled}
        isHotel={isHotel}
      >
        <Icon icon="ChevronLeftIcon" fontsize="titleNormal" color="default" />
      </LeftArrowButton>
    </LeftArrowWrapper>
  );
};

LeftArrow.propTypes = {
  onClick: func,
  disabled: bool,
  isHotel: bool,
};

export default LeftArrow;
